import { useState, useEffect } from "react"
import { useUpdateResponseMutation, useDeleteResponseMutation, useGetResponsesQuery, useGetResponseByIdQuery } from "./responsesApiSlice"
import { useGetActionsQuery } from "../actions/actionsApiSlice"

import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faSave, faTrashCan, faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import { useParams } from "react-router-dom"
import EditNewResponseHeader from "./EditNewResponseHeader"
import ResponseText from "../../partial/ResponseText"
import ResponseCode from "../../partial/ResponseCode"
import ResponseFile from "../../partial/ResponseFile"
import AdditionList from "../../partial/AdditionList"
import PulseLoader from "react-spinners/PulseLoader"
import BooleansResponse from "../../partial/BooleansResponse"
import getFilePath from "../../utils/getFilePath"
import { FriendsCheckbox } from "../../components/FriendsCheckbox"
const EditResponseForm = () => {
    const { actionId, responseId, groupId, type: urlType  } = useParams()
    const { action } = useGetActionsQuery("actionsList", {
        selectFromResult: ({ data }) => ({
            action: data?.entities[actionId]
        }),
    })  
    // const { response } = useGetResponsesQuery("responsesList", {
    //     selectFromResult: ({ data }) => ({
    //         response: data?.entities[responseId]
    //     }),
    // })
    const {
        data: response,
    } = useGetResponseByIdQuery({id:responseId})
    const { isTeacher, isAdmin } = useAuth()
    const navigate = useNavigate()
    const [updateResponse, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateResponseMutation()

    const [deleteResponse, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteResponseMutation()

    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setBody('')
            setComments('')
            setBooleans({})
            navigate(`/${urlType}/${groupId}/tasks/${action.task}/actions`)
        }

    }, [isSuccess, isDelSuccess, navigate])
    const [body, setBody] = useState(response.body)
    const [comments, setComments] = useState(response.comments)
    const [additions, setAdditions] = useState(response.additions)
    const [booleans, setBooleans] = useState(response.booleans)
    const [friends, setFriends] = useState(response.friends || [])

    const additionOk = () =>{
        let flag = true
        if(!action.additions?.length) {
            return flag;
        }
        const ids  = action.additions.filter(x=>x.required).map(addition=>addition._id)
        if(!ids.length) {
            return flag;
        }
        if(!additions) /*no addition but there are some that required*/
        {
            flag = false;
            return flag;
        }

        ids.map(id=>{
           const currAddition = additions.filter(addition=>id ===addition.qid);
            if(!currAddition?.length ||!currAddition[0].body) {
                flag = false;
                return flag;
            } 
        })
        return flag;
    }
    if (!action ) return <PulseLoader color={"#FFF"} />
    const canSave = [body].every(Boolean) && !isLoading && additionOk()

    const onSaveResponseClicked = async (e) => {
        if (canSave) {
            await updateResponse({ id: response.id, body,comments, additions, booleans,action:actionId, friends })
        }
    }

    const onDeleteResponseClicked = async () => {
        await deleteResponse({ id: response.id })
    }

    const created = new Date(response.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(response.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })


    const errClass = isError ? "errmsg" : "offscreen"


    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isTeacher || isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteResponseClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }
    const type = action?.type || "Text"

    const content = (
        <>
      
            <p className={errClass}>{errContent}</p>

            <form className="form"  onSubmit={e => e.preventDefault()}>
                <EditNewResponseHeader response={response.group} />
                <div className="form__title-row">

                     <div className="form-top-bottons">
                     <button
                            className="icon-button"
                            title="Back to action"
                            onClick={()=>{ navigate(`/${urlType}/${groupId}/tasks/${action.task}/actions`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                            onClick={onSaveResponseClicked}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                     
                        {deleteButton}
                    </div>
                </div>
                {action.img && <img className="user-img" src={getFilePath(action.img)} />}

                <>
                    {type==="Text"&& <ResponseText action={action} body={body} setBody={setBody} />}
                    {type==="Code"&& <ResponseCode action={action} body={body} setBody={setBody} />}
                    {type==="File"&& <ResponseFile action={action} body={body} setBody={setBody} />}
                  
                </>
    
                         
                <AdditionList action={action} additions={additions} setAdditions={setAdditions} />
                <BooleansResponse action={action} booleans={booleans} setBooleans={setBooleans} />
                <FriendsCheckbox group={response?.group} friends={friends} setFriends={setFriends} />
                <label className="form__label" htmlFor="comments">
                    הערות משתמש:</label>
                <textarea
                    className={`form__input form__input--text`}
                    id="comments"
                    name="comments"
                    value={comments}
                    onChange={(e)=>setComments(e.target.value)}
                />
           
                <div className="form__row">
                    <div className="form__divider">

                        <div className="form__divider">
                            <p className="form__created">Created:<br />{created}</p>
                            <p className="form__updated">Updated:<br />{updated}</p>
                        </div>
                    </div>
                </div>               
            </form>
        </>
    )

    return content
}

export default EditResponseForm